import smoothscroll from 'smoothscroll-polyfill';

export default {
    _alert : null,

    init() {
        this._alert =  document.querySelector('.fui-alert');
        let errorClass =  document.querySelector('.fui-errors');
        if(errorClass) {
            this._alert = errorClass;
        }
        if(!(this._alert)){
            return;
        }
        smoothscroll.polyfill();
        setTimeout(() => {
            this._alert.scrollIntoView( { behavior: 'smooth' , block: 'start', inline: 'nearest'});
        }, "50")

    }
}
